'use strict';

const h = require('phy');
const EnrollmentIframe = require('./enrollment_iframe');

const EnrollmentModal = props => {
  const { closeModalText } = props;
  const closeIcon = h(
    'div.close-modal-container',
    h('a.close-modal.icon-x.close', closeModalText)
  );

  return h(
    'div.modal#select-widget-enrollment-modal',
    {
      role: 'dialog',
      'data-bhw': 'SelectEnrollmentModal',
      'data-bh-viewport': 'respect',
      'data-closeonbgclick': 'false',
    },
    h(
      'div',
      closeIcon,
      h(
        'div.modal-body.fx-row',
        h('div.columns#enrollment-modal-benefits'),
        h(
          `div.columns#enrollment-modal-iframe-column`,
          h(EnrollmentIframe, props)
        )
      )
    )
  );
};

module.exports = EnrollmentModal;
